import type { AxiosInstance } from 'axios';
import type { CiselnikyCiselnikPolozkaSeznamDto } from '../generated';

export const legalFormQuery = async (
	axiosInstance: AxiosInstance
): Promise<CiselnikyCiselnikPolozkaSeznamDto> => {
	const { data } = await axiosInstance.get(
		'/api/v1/ciselniky/ROS_PRAVNI_FORMA/polozky'
	);
	return data;
};
